/**Dependecies */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Modal,
  Button,
  Form,
} from "react-bootstrap";
import useForm from "../hooks/useForm";
/**Styles */
import "../styles/components/header.scss";

/**Images */
import { FaFacebook, FaInstagram } from "react-icons/fa";
import logo from "../images/logo-international.png";
import agentContact from "../images/agenda-consulta.png";

// Services
import { getEmailText } from "../services/emailService";

/**Componente para renderizar el header*/
export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  let initialState = {
    emailAddress: "info@tranet.com.mx",
    destinatarioCC: "hola@marketingdirigido.com",
    asunto: "Han Solicitado información",
    fullName: "",
    email: "",
    date: "",
    phone: "",
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit, resetForm } = useForm(
    initialState,
    validations
  );

  /**
   * Función para manejar el envío del formulario de contacto,
   * esta función se encarga de tomar los datos del formulario,
   * llamar al servicio para enviar el correo y mostrar un mensaje
   * de success o error dependiendo del resultado.
   *
   * @param {Event} e - El evento que se desencadena al enviar el formulario.
   * @returns {Promise<void>}
   */
  const submitForm = async () => {
    const dataArray = {
      destinatario: formData.emailAddress,
      destinatarioCC: formData.destinatarioCC,
      asunto: formData.asunto,
      mensaje: `Nombre completo: ${formData.fullName} \nEmail: ${formData.email} \nFecha de llamada: ${formData.date} \nNúmero de teléfono: ${formData.phone}`, // Usa la interpolación correctamente
    };

    try {
      await getEmailText(dataArray);
      resetForm();
      Swal.fire({
        title: "Correo enviado exitosamente!",
        text: "El correo ha sido enviado, nos contactaremos con usted lo antes posible.",
        icon: "success",
      });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      Swal.fire({
        icon: "error",
        title: "Hubo un error al enviar el correo.",
        text: "Por favor intentelo mas tarde.",
      });
    }
  };

  return (
    <>
      {/**Contenedor numeros telefonicos */}
      <nav
        className="logo logo-container d-flex justify-content-end"
        style={{ padding: "15px" }}
      >
        <div className="container d-flex justify-content-end">
          <Row className="align-items-center">
            <Col
              lg={12}
              className="d-flex justify-content-center align-items-center"
            >
              <a
                href="tel:+7773128531"
                style={{ marginRight: "15px" }}
                className="phone-numbers"
              >
                777 312 8531
              </a>
              <a
                href="tel:+7772035097"
                style={{ marginRight: "15px" }}
                className="phone-numbers"
              >
                777 203 5097
              </a>
              <a
                href="https://www.facebook.com/ViajesTranet"
                target="_blank"
                className="text-white"
                style={{ marginRight: "15px" }}
                rel="noreferrer"
              >
                <FaFacebook className="icon-media" />
              </a>
              <a
                href="https://www.instagram.com/travelnetcuerna?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                className="text-white margin-right-ig"
                rel="noreferrer"
              >
                <FaInstagram className="icon-media" />
              </a>
            </Col>

            {/* <Col xs={6} md={3} lg={5} className="d-flex justify-content-center">
             
            </Col>
            <Col xs={6} md={3} lg={1} className="d-flex justify-content-center">
            
            </Col>
            <Col xs={6} md={3} lg={1} className="d-flex justify-content-center">
             
            </Col> */}
          </Row>
        </div>
      </nav>
      {/**Links de las vistas */}
      <Navbar expand="lg" className="navbar-international" expanded={menuOpen}>
        <Container>
          <Navbar.Brand
            as={Link}
            to={"/"}
            onClick={() => sessionStorage.clear()}
          >
            <img
              src={logo}
              alt="Logo"
              className="d-inline-block align-top"
              style={{ width: "140px", height: "140px" }}
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setMenuOpen(!menuOpen)}
          />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto navbar-flex-mobile">
              {" "}
              {/* Centrar los links */}
              <Nav.Link
                as={Link}
                to={"/destinos"}
                onClick={() => setMenuOpen(false)}
              >
                Destinos
              </Nav.Link>
              <Nav.Link
                as={Link}
                to={"/circuitos"}
                onClick={() => setMenuOpen(false)}
              >
                Circuitos
              </Nav.Link>
              <Nav.Link
                as={Link}
                to={"/promociones"}
                onClick={() => setMenuOpen(false)}
              >
                Promociones
              </Nav.Link>
              <Nav.Link
                as={Link}
                to={"/cursos"}
                onClick={() => setMenuOpen(false)}
              >
                Cursos y campamentos
              </Nav.Link>
            </Nav>

            <Nav className="navbar-hide-mobile">
              <Nav.Link onClick={handleShowModal}>
                <img
                  src={agentContact}
                  alt="Usuario"
                  style={{ height: "140px", width: "140px" }}
                />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {/**Modal para formulario de contacto */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        className="modal-header"
      >
        <Modal.Header className="mx-auto">
          <Modal.Title>Contáctanos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => handleSubmit(e, submitForm)}>
            <Form.Group controlId="formName" className="mb-3">
              <Form.Label>Nombre Completo</Form.Label>
              <Form.Control
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                style={{ fontSize: "14px" }}
                required
              />
            </Form.Group>
            <br />
            <Form.Group controlId="formEmail" className="mb-3">
              <Form.Label>Correo electrónico</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={{ fontSize: "14px" }}
                required
              />
            </Form.Group>
            <br />
            <Form.Group controlId="formFecha">
              <Form.Label>Fecha en la que podemos contactarte</Form.Label>
              <Form.Control
                type="date"
                name="date"
                min={new Date().toJSON().slice(0, 10)}
                value={formData.date}
                onChange={handleChange}
                style={{ fontSize: "14px" }}
                required
              />
            </Form.Group>
            <br />
            <Form.Group controlId="formPhone" className="mb-3">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                style={{ fontSize: "14px" }}
                maxLength={10}
                required
              />
            </Form.Group>

            <div className="d-flex justify-content-center pt-5">
              <Button
                variant="light"
                type="submit"
                className="btn-blue text-white"
                style={{ width: "20%", fontSize: "14px" }}
              >
                Enviar
              </Button>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            style={{ width: "20%", fontSize: "14px" }}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
